import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorPage from "../../Components/ErrorPage";
import EmptyView from "../ViewComponents/EmptyView";
import DeleteRecordModal from "../ViewComponents/DeleteRecordModal";
import LoadingRows from "../ViewComponents/LoadingRows";
import TableAccess from "../TableEngine/TableAccess";
import { Dropdown } from "react-bootstrap";
import { IoOpenOutline } from "react-icons/io5";
import { VscAzure, VscGitPullRequestCreate } from "react-icons/vsc";
import { PiDatabaseLight } from "react-icons/pi";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { SiGooglecloud } from "react-icons/si";
import { FaAws } from "react-icons/fa";
import LoadingCubes from "../ViewComponents/LoadingCubes";
import regionDisplayNames from "../../JSON/AzureDisplayNames.json"
import EmptyViewComingSoon from "../ViewComponents/EmptyViewComingSoon";

const MainPlaybox = ({ userData, no_session }) => {
    const { t } = useLanguage()
    const navigate = useNavigate();
    const { project_id } = useParams()
    const user_id = sessionStorage.getItem("user_id");
    const [records, setRecords] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [activeFilter, setActiveFilter] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [animateReset, setAnimateReset] = useState(false)

    const new_item_navigate = `/project_panel/${project_id}/playbox/new_playbox`
    const title_empty = "Playbox"
    const subtitle_empty = "Playboxes provide an environment for running code."
    const item = "playbox"



    const navigateToNewProject = () => {
        navigate(new_item_navigate);
    };

        const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_playboxes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });
            if (response.ok) {
                const result = await response.json();
                let playboxData = result.playboxes || {};
                let filteredData = [];

                for (let key in playboxData) {
                    if (playboxData[key].project_id === project_id) {
                        filteredData.push(playboxData[key]);
                    }
                }

                const recordsArray = Object.values(filteredData);
                recordsArray.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                setRecords(recordsArray);
                setFilteredRecords(recordsArray);
                setActiveFilter("newest")
            } else {
                setError(true);
            }
        } catch (err) {
            setLoading(false)
            setError(true);
        }finally{
             setTimeout(() => {
                setLoading(false)
            }, 500);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, [user_id]);

    const handleSort = (criteria) => {
        setActiveFilter(criteria);
        let sortedRecords = [...records];
        if (criteria === "alphabetical") {
            sortedRecords.sort((a, b) => a.k8sname.localeCompare(b.k8sname));
        } else if (criteria === "reverseAlphabetical") {
            sortedRecords.sort((a, b) => b.k8sname.localeCompare(a.k8sname));
        } else if (criteria === "newest") {
            sortedRecords.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        } else if (criteria === "oldest") {
            sortedRecords.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
        }
        setFilteredRecords(sortedRecords);
    };

    const resetFilters = () => {
        setActiveFilter("");
        setSearchQuery("")
        setAnimateReset(true)
        setTimeout(() => {
            setAnimateReset(false)
        }, 1000);
        setFilteredRecords(records);
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredRecords(records);
            return;
        }

        const filtered = records.filter((record) => {
            return (
                record._id.toLowerCase().includes(query) ||
                record.project_id.toLowerCase().includes(query) ||
                record.k8sname.toLowerCase().includes(query) ||
                record.selectedRegion.toLowerCase().includes(query) ||
                record.osType.toLowerCase().includes(query) ||
                record.clus_desc.toLowerCase().includes(query) ||
                record.vm_size.toLowerCase().includes(query) ||
                record.timestamp.toLowerCase().includes(query) ||
                record.status.toLowerCase().includes(query) ||
                record.agent_pool_name.toLowerCase().includes(query) ||
                record.provider.toLowerCase().includes(query)
            );
        });

        setFilteredRecords(filtered);
    };

    const handleDeleteClick = (accID) => {
        setSelectedRecordId(accID);
        setShowDeleteModal(true);
    };

    const handleCloseModal = () => {
        setShowDeleteModal(false);
        setSelectedRecordId(null);
    };

    const handleEditClick = (accID) => {
        const recordObject = records.find((record) => record._id === accID)
        sessionStorage.setItem("access_object", JSON.stringify(recordObject))
        navigate(`/project_panel/${project_id}/access/update_access/${accID}`)
    };

    if (loading) {
        return <LoadingCubes />;
    } else if (error) {
        return <ErrorPage />;
    } else if (records.length === 0) {
        return <EmptyView navigate_link={new_item_navigate} title={title_empty} subtitle={subtitle_empty} item={item} />
    }

    return (
        <div className="main_view_container">
            <div className="header_main_view fade-in">
                <div className="header_title">
                    <p className="main_view_title">Playbox</p>
                    <p className="main_view_subtitle">{subtitle_empty}</p>
                    <button className="connect_email_btn" onClick={navigateToNewProject}>
                        <i className="fa-solid fa-plus"></i> {t.create}
                    </button>
                </div>
                {/* <img className="icon_img" src={item} alt="Access icon" /> */}
            </div>
            <div className="filter_container fade-in">
                {records.length > 1 && (
                    <>
                        <button
                            className={`filter_btn ${activeFilter === "alphabetical" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("alphabetical")}
                        >
                            <i className="fa-solid fa-arrow-down-wide-short"></i> A-Z
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "reverseAlphabetical" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("reverseAlphabetical")}
                        >
                            <i className="fa-solid fa-arrow-up-short-wide"></i> Z-A
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "newest" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("newest")}
                        >
                            {t.from_newest}
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "oldest" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("oldest")}
                        >
                            {t.from_oldest}
                        </button>
                    </>
                )}
                <button
                    className={`filter_btn ${activeFilter === "reset" ? "clicked_filter" : ""}`}
                    onClick={resetFilters}
                >
                    <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                </button>
                <div className="filter_input_cont">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                        className="filter_input"
                        placeholder={t.search}
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
            </div>
            <div className="organizations_cont">
                {filteredRecords.map((record) => (
                    <div key={record._id} className="organization_item fade-in">
                        <p className="organization_title" onClick={() => {
                             if (record.status == "deleting") {
                                navigate(`/project_panel/${project_id}/playbox`);
                            } else {
                                navigate(`/project_panel/${project_id}/playbox/${record._id}/logs`);
                            }
                        }}>{record.playbox_name}
                            {record.status == "deleted" ? (
                                <span className="title_status failed_cluster"><i className="fa-solid fa-x"></i> Deleted</span>
                            ) : record.status == "active" ? (
                                <span className="title_status running_cluster"><i className="fa-solid fa-check"></i> Active</span>
                            ) : (
                                <span className="title_status loading_cluster"><i className="fa-solid fa-circle"></i></span>
                            )}</p>
                        <p className="organization_desc">{record.playbox_desc}</p>


                        <div className="organization_footer">
                            <Dropdown>
                                <div className="property_btn_action_toggle">
                                    <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                        <i className="fa-solid fa-ellipsis-vertical"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="custom-dropdown-menu">
                                        {/* <Dropdown.Item
                                            className="drop_down_item"
                                            onClick={() => handleEditClick(record._id)}
                                        >
                                            <i className="fa-solid fa-pencil"></i> {t.edit} {record.project_name}
                                        </Dropdown.Item> */}
                                        <Dropdown.Item
                                            className="drop_down_item delete"
                                            onClick={() => handleDeleteClick(record._id)}
                                        >
                                            <i className="fa-solid fa-trash"></i> {t.delete}
                                        </Dropdown.Item>

                                    </Dropdown.Menu>
                                </div>
                            </Dropdown>
                            <div className="footer_items_org">
                                <p>{record.provider == "azure" ? (
                                    <i><VscAzure /></i>
                                ) : record.provider == "gc" ? (
                                    <i><SiGooglecloud /></i>
                                ) : record.provider == "aws" ? (
                                    <i><FaAws /></i>
                                ) : (
                                    <i><VscAzure /></i>
                                )}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <DeleteRecordModal
                show={showDeleteModal}
                handleClose={handleCloseModal}
                recordObject={records.find((record) => record._id === selectedRecordId)}
                fetchRecords={fetchRecords}
                endpoint={"delete_playbox"}
                record_type={"playbox"}
                message="This action can be undone later. This database will be deleted but data will be preserved in backup."
            />
        </div>
    );
};

export default MainPlaybox;
